(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvDataGrid', DataGrid);

    DataGrid.$inject = [];
    
    /**
     * @ngdoc directive
     * @name drvDataGrid
     *
     * @description
     * A directive for presenting a list of data with a loading animation and paging tool.
     * 
     * Consumer must provide:
     * - Repeating layout within element (content is transcluded).
     * - Attributes for totalItems and pageNumber, other attributes are optional.
     * 
     *
     * # Mandatory Parameters
     *
     * @param {number} totalItems - The total of items for the grid, required for paging control to work.
     * @param {number} pageNumber - The page number.
     *
     *
     * # Optional Parameters
     *
     * @param {bool} loading - Optional. Indicates whether data is loading.
     * @param {number} itemsPerPage - Optional. Items per page for paging control. Defaults to 10 if unspecified. If the value is not defined in the page size options list, it will be added.
     * @param {string|Object} error - Optional. An error to display. If this value is not null, the content is hidden,
     * and detail of the error shown instead. If error is a string, it is displayed as-is. If error is a response
     * object from Angular $http service, the directive will determine what text to display.
     * @param {function} onChange - Callback which is invoked when the page size or page number is changed. Optional
     *
     */
    function DataGrid() {
        var directive = {
            link: link,
            restrict: 'EA',
            transclude: true,
            templateUrl: 'app/data-grid.tmpl.html',
            scope: {
                totalItems: '=',
                pageNumber: '=',
                loading: '=?',
                itemsPerPage: '=?',
                error: '=?',
                onChange: '&?'
            },
            controller: controller
        };
        return directive;

        function link(scope, element, attrs) {
            /*
             * Setup the page size options list
             */
            var pageSizeOptions = [
                { label: '10', value: 10 },
                { label: '25', value: 25 },
                { label: '50', value: 50 }
            ];

            if (!_.isNil(scope.itemsPerPage)) {
                if (!_.find(pageSizeOptions, function (pageSizeOption) {
                    return pageSizeOption.value === scope.itemsPerPage;
                })) {
                    pageSizeOptions.push({ label: scope.itemsPerPage, value: scope.itemsPerPage });
                }
            } else {
                scope.itemsPerPage = 10;
            }

            scope.pageSizeOptions = _.sortByOrder(pageSizeOptions, ['value'], ['asc']);
            scope.pageSizeOptions.push({ label: 'All', value: undefined });

            /*
             * Setup watches for the onChange callback
             */


            scope.$watch('pageNumber', function (newVal, oldVal) {
                if (newVal !== oldVal && !_.isNil(scope.onChange)) {
                    scope.onChange();
                }
            });

            scope.getErrorText = function () {
                if (!angular.isDefined(scope.error) || scope.error === null) {
                    return null;
                } else if (angular.isString(scope.error)) {
                    return scope.error;
                } else if (scope.error.data && scope.error.data.Message) {
                    return scope.error.data.Message;
                } else if (scope.error.status === -1) {
                    return 'Error fetching data. There was a network communication error.';
                } else {
                    return 'Error fetching data.';
                }
            };
        }

        function controller() {
        }
    }

})();